import React, { useState, useContext } from "react";
import * as GrIcons from "react-icons/gr";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const programs = ["EL", "SPED", "WIOA"];

const AddSpecialProgramsModal = () => {
  const adminRegistration = useContext(AdminRegistrationContext);
  const { addSpecialPrograms, registration, setFormModal } = adminRegistration;
  const [programList, setProgramList] = useState(registration.programs);
  const [programDescription, setProgramDescription] = useState(
    registration.programDescription ? registration.programDescription : ""
  );

  const handleOnChange = (e) => {
    setProgramList({
      ...programList,
      [e.target.name]: {
        ...{ unchecked: false, true: false, false: false },
        [e.target.value]: e.target.checked,
      },
    });
  };

  const handleSubmit = () => {
    addSpecialPrograms({ programList, programDescription }, registration._id);
    setFormModal("specialProgramsModal", false);
  };
  return (
    <div id="special-programs-modal" className="modal">
      <div className="spceial-programs-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("specialProgramsModal", false)}
          />
          <h2>Add Special Programs</h2>
        </div>
        <div className="modal-body">
          <div className="add-special-programs">
            <div className="tag-select">
              <p>Select Programs for Student</p>
              <div className="programs-container">
                {registration.programs &&
                  Object.keys(registration.programs).map((item) => {
                    return (
                      <div className="item">
                        <h4>
                          {item === "fiveZeroFour" ? "504" : item.toUpperCase()}
                          :{" "}
                        </h4>
                        <div className="flex-check-container">
                          <label className="check-container">
                            Unverified
                            <input
                              type="radio"
                              value="unchecked"
                              checked={programList[item].unchecked}
                              onChange={(e) => handleOnChange(e)}
                              name={item}
                            />
                            <span className="styled-checkmark"></span>
                          </label>
                          <label className="check-container">
                            Yes
                            <input
                              type="radio"
                              value="true"
                              checked={programList[item].true}
                              onChange={(e) => handleOnChange(e)}
                              name={item}
                            />
                            <span className="styled-checkmark"></span>
                          </label>
                          <label className="check-container">
                            No
                            <input
                              type="radio"
                              value="false"
                              checked={programList[item].false}
                              onChange={(e) => handleOnChange(e)}
                              name={item}
                            />
                            <span className="styled-checkmark"></span>
                          </label>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="program-description form">
              <p>Add Program Notes</p>
              <textarea
                value={programDescription}
                onChange={(e) => setProgramDescription(e.target.value)}
                cols="30"
                rows="5"
              ></textarea>
            </div>
            <div className="btn-container"></div>
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            <div className="btn btn-llac-dark-green" onClick={handleSubmit}>
              Submit
            </div>
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("specialProgramsModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSpecialProgramsModal;
